
  import { css } from 'lit';
  export const styles = css`:host{--color: var(--ig-divider-color, var(--ig-gray-100));--ig-theme: indigo;--ig-theme-variant: dark}`;
  